export default "__VITE_ASSET__YSA8MaLi__"